import React from 'react';
import styled from 'styled-components';

import MultiSelectDropdown from 'src/presentation/components/pages/shared/MultiSelectDropdown';
import { GroupHeader } from '@ad-scripts/presentation/components/common/multi_select_dropdown_menu';

type EntryPointType = {
  className?: string;
  entryPointElement?: JSX.Element;
  inboxElement: JSX.Element;
  slaElement: JSX.Element;
};

export const EntryPointItemRow = ({
  className,
  entryPointElement,
  inboxElement,
  slaElement,
}: EntryPointType): JSX.Element => (
  <StyledContainer className={`${className}-row`} twoColumns={!entryPointElement}>
    {entryPointElement && <div>{entryPointElement}</div>}
    <div>{inboxElement}</div>
    <div>{slaElement}</div>
  </StyledContainer>
);

export const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 240px) minmax(0, 240px) 120px;
  grid-gap: 16px;

  ${p =>
    p.twoColumns &&
    `
      grid-template-columns: minmax(0, 240px)  120px minmax(0, 240px);
  `}
`;

export const StyledMultiSelectDropdown = styled(MultiSelectDropdown)`
  ${GroupHeader}[data-aid='header-level-1'] {
    color: ${p => p.theme.colors.gray700};
    font-weight: ${p => p.theme.fontWeight.heavy};
  }
`;
